<template>
  <li
    v-if="canViewVerticalNavMenuLink(item)"
    class="nav-item"
    :class="[
      item.itemClass || '',
      {
        'active': isActive,
        'disabled': item.disabled
      },
    ]"
  >
    <b-link
      v-if="check(item.roles)"
      v-bind="linkProps"
      class="d-flex align-items-center"
      :class="item.linkClass || ''"
      @click="handleClick"
    >
      <feather-icon :icon="item.icon || 'CircleIcon'" />
      <span
        class="menu-title text-truncate"
        :class="item.titleClass || ''"
      >{{ t(item.title) }}</span>
      <feather-icon
        v-if="item.deletable && isActive"
        icon="Trash2Icon"
        size="13"
        class="prep-budget-link-delete"
        title="Menü törlése"
        @click.stop.prevent="handleDelete"
      />
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
  </li>
</template>

<script>
import { useUtils as useAclUtils } from '@core/libs/acl'
import { BLink, BBadge } from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'

export default {
  components: {
    BLink,
    BBadge,
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    check(roles) {
      const user = JSON.parse(localStorage.getItem('user'))
      const userRoles = (user && user.role) || []
      if (this.item.developerOnly && !userRoles.includes('developer_role')) return false
      if (Array.isArray(roles)) return roles.some(role => userRoles.includes(role))
      return userRoles.includes(roles)
    },
    handleClick(event) {
      if (this.item && typeof this.item.onClick === 'function') {
        const result = this.item.onClick()
        if (result === false && event && typeof event.preventDefault === 'function') {
          event.preventDefault()
        }
      }
    },
    handleDelete() {
      if (this.item && typeof this.item.onDeleteClick === 'function') {
        this.item.onDeleteClick()
      }
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(props)
    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuLink } = useAclUtils()

    return {
      isActive,
      linkProps,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuLink,

      // i18n
      t,
    }
  },

}
</script>

<style scoped>
.prep-budget-link-delete {
  margin-left: auto;
  margin-right: 0.15rem;
  color: #ef4444;
  opacity: 0.85;
  cursor: pointer;
}

.prep-budget-link-delete:hover {
  color: #f87171;
  opacity: 1;
}

.nav-item.km-import-item > a svg {
  display: none;
}

.nav-item.km-import-item > a::before {
  content: '';
  width: 8px;
  height: 8px;
  border: 1.4px solid currentColor;
  border-radius: 1px;
  margin-right: 1.38rem;
  opacity: 0.9;
  flex: 0 0 auto;
}

.nav-item.km-import-item > a .menu-title {
  font-size: 0.88rem;
}

.vertical-layout .main-menu .navigation > li > ul li.nav-item.km-import-item > a {
  padding-left: 2.4rem !important;
}

.nav-item.km-import-item.active {
  background: transparent !important;
  box-shadow: none !important;
  border-radius: 0 !important;
}

.nav-item.km-import-item.active > a {
  background: transparent !important;
  box-shadow: none !important;
  color: inherit !important;
  font-weight: 400 !important;
}
</style>
